import styles from '../../../../common/preview-block/Preview.module.scss';
import React from 'react';

const Preview = () => {
  return (
    <div className={styles.template_preview_container}>
      <h2>Business Profile Overview</h2>
      <p>
        Welcome to your Business Profile, the one place to keep your business details, contacts,
        notes and key documents. Keeping it up to date means your details flow into the documents
        you create on the platform.
      </p>
      <h2>Quick actions</h2>
      <ul>
        <li>
          <strong>Upload Files:&nbsp;</strong>upload up to 5 files at once (DOC, DOCX, PDF, PNG,
          JPEG or HEIC), assign them to a Profile and choose a workflow folder.
        </li>
        <li>
          <strong>Start eSigning:&nbsp;</strong>upload a PDF, assign it to a Profile and workflow
          folder, then send it for eSigning.
        </li>
        <li>
          <strong>Create Contact:&nbsp;</strong>add a person, such as a director or shareholder, and
          tick their roles.
        </li>
      </ul>
      <h2>Using the tabs</h2>
      <ul>
        <li>
          <strong>Documents:&nbsp;</strong>view all your documents, organised into workflow folders.
        </li>
        <li>
          <strong>Details:&nbsp;</strong>keep your business name, registration number, tax ID, phone
          number and registered address up to date. These details auto-fill into documents you
          create.
        </li>
        <li>
          <strong>Contacts:&nbsp;</strong>see your Director, Accountant and Secretary at a glance,
          and manage each contact's details and roles, such as Authorised signatory, Shareholder,
          Hiring Manager or Legal Representative.
        </li>
        <li>
          <strong>Notes:&nbsp;</strong>record internal updates, decisions or context about your
          business.
        </li>
      </ul>
      <h2>Workflow folders</h2>
      <ul>
        <li>
          <span>Your documents are sorted into six folders:&nbsp;</span>
          <strong>
            Business registration and ownership, Accounting, Agreement, General administration,
            Insurance and licences and Assets.
          </strong>
        </li>
        <li>
          <strong>Details:&nbsp;</strong>keep your business name, registration number, tax ID, phone
          number and registered address up to date. These details auto-fill into documents you
          create.
        </li>
        <li>
          Choose a folder when you upload a file or start eSigning, so everything is easy to find
          later.
        </li>
        <li>
          <strong>Tip:&nbsp;</strong>use Documents view (top right) to switch between Card and List
          view.
        </li>
      </ul>
      <h2>Video tutorials</h2>
      <ul>
        <li>
          <a
            id='businessProfilePreviewHowToCreateABusinessLink'
            href='https://youtu.be/KMb0gFgAoMw?si=ZaLqZMavjYb1_PGY'
            target='_blank'
            rel='noopener noreferrer'
          >
            How to create a Business Profile
          </a>
        </li>
      </ul>
    </div>
  );
};

export default Preview;
